export default function Hero() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20sci-fi%20comic%20book%20illustration%20deep%20space%20background%20with%20vibrant%20nebula%20swirling%20galaxy%20distant%20planets%20stars%20comic%20panel%20borders%20subtle%20halftone%20texture%20warm%20orange%20gold%20accents%20against%20dark%20cosmic%20void%20dramatic%20cinematic%20lighting%20rich%20color%20gradient%20immersive%20atmosphere%204k%20quality&width=1600&height=1000&seq=hero-bg-comic&orientation=landscape"
          alt="星球漫画 - 星际科幻漫画背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-background-950/50 to-background-950/30 z-[1]"></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-24 md:pt-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12 py-10 md:py-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="inline-block text-xs md:text-sm font-medium tracking-widest uppercase text-accent-400 bg-accent-950/40 px-3 py-1 rounded-full mb-4 md:mb-5">
              科幻漫画 · 星际冒险
            </p>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-3 md:mb-4">
              星球漫画，星际科幻漫画免费阅读平台
            </h1>

            <p className="text-base md:text-lg text-accent-300 font-medium mb-5 md:mb-6">
              下拉式阅读，畅享宇宙故事
            </p>

            <p className="text-sm md:text-base text-background-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6 md:mb-8">
              星球漫画汇聚全网高品质星际漫画、科幻漫画与宇宙漫画资源，涵盖星球大战、太空冒险、星际探索等热门题材。
              每日更新多部漫画章节，采用流畅下拉式阅读体验，无需翻页即可沉浸畅读。
              无论你是硬核科幻迷还是轻度漫画爱好者，这里都是你探索宇宙故事的最佳入口。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="flex items-center gap-2 text-background-200/80">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-refresh-line text-accent-400 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm whitespace-nowrap">每日更新</span>
              </div>
              <div className="flex items-center gap-2 text-background-200/80">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-book-open-line text-accent-400 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm whitespace-nowrap">万部漫画</span>
              </div>
              <div className="flex items-center gap-2 text-background-200/80">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-hd-line text-accent-400 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm whitespace-nowrap">高清画质</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleScroll('#index'); }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-colors no-underline text-sm md:text-base cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-play-circle-line"></i>
                </span>
                开始阅读
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 border border-background-300/40 hover:border-background-200/60 text-background-100 hover:text-background-50 font-medium rounded-full transition-colors no-underline text-sm md:text-base cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-line"></i>
                </span>
                热门推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] sm:w-[320px] sm:h-[440px] md:w-[380px] md:h-[520px] lg:w-[420px] lg:h-[560px]">
              <img
                src="https://readdy.ai/api/search-image?query=Stunning%20sci-fi%20comic%20book%20cover%20illustration%20a%20brave%20space%20explorer%20in%20futuristic%20armor%20standing%20on%20an%20alien%20planet%20surface%20with%20twin%20moons%20and%20vibrant%20purple%20orange%20nebula%20in%20sky%20comic%20panel%20borders%20speech%20bubbles%20dynamic%20action%20pose%20manga%20meets%20western%20comic%20art%20style%20cinematic%20lighting%20rich%20colors%20detailed%20illustration&width=840&height=1120&seq=hero-visual-main&orientation=portrait"
                alt="星球漫画 - 星际科幻冒险主题视觉"
                className="w-full h-full object-cover rounded-2xl shadow-2xl shadow-background-950/50"
              />
              <div className="absolute -bottom-3 -right-3 w-20 h-20 md:w-24 md:h-24 rounded-xl bg-primary-500/90 flex items-center justify-center">
                <span className="text-background-50 font-heading font-bold text-xs md:text-sm leading-tight text-center">
                  免费<br />全集
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}